const BankCardComponent = () => import('@/views/finance/BankCard/BankCardView')

export default [
    {
        path:'/BankCardIndex',
        name:'BankCardComponent',
        component:BankCardComponent
    }
]